import { render, staticRenderFns } from "./TagEditDialog.vue?vue&type=template&id=2345f5eb&scoped=true"
import script from "./TagEditDialog.vue?vue&type=script&lang=ts"
export * from "./TagEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./TagEditDialog.vue?vue&type=style&index=0&id=2345f5eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2345f5eb",
  null
  
)

export default component.exports